export enum FeatureEnvironments {
  Dev = 'dev',
  UAT = 'uat',
  Production = 'production',
}

export enum SdkKeys {
  dev = 'MtZGXZWTnDViK8dwztDJR',
  uat = 'WgM5eNGMEt5QfZ11gfs4D7',
  production = '3mwDSnYYpzqfT5MDner8cb',
}

export enum FEATURES {
  ssoOnRemoteActivation = 'sso_on_remote_activation',
  IsRemoteActivationFlowImprovementsEnabled = 'remote_activation_flow_improvements',
}
